import { Component, Input, OnInit, TemplateRef, ContentChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { UserContextService } from '../../../services/service/user-context.service';
import { SubscriptionManager } from '../../../services/service/subscription-mamager';

import { NavMenu, NavMenuItem, NavMenuItemActionType } from '../../model/nav-menu';

@Component({
  selector: 'zx-breadcrumb-block',
  templateUrl: './breadcrumb-block.component.html',
  styleUrls: [ './breadcrumb-block.component.css' ],
})
export class BreadcrumbBlockComponent implements OnInit,OnDestroy {

	private _appendings: any[];
	items : any[];
 	@Input() showHomeIcon:boolean = true;

	@ContentChild('extra', {static:true}) tpl_extra: TemplateRef<void>;

    constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private userContext: UserContextService,
        private subscriptionManager: SubscriptionManager,
	) { }

    ngOnInit() {
    	this.initBreadcrumb();
    	this.subscriptionManager.register(this, this.userContext.dataChange.subscribe(data=>{
    		if(data.key == "MainSiderMenu"){
    			this.initBreadcrumb();
    		}
    	}));
	}
	ngOnDestroy(){
		this.subscriptionManager.unsubscribe(this);
	}
	
	@Input() set appendings(value: any[]) {
		this._appendings = value;
		this.initBreadcrumb();
	}
	get appendings(): any[] {
		return this._appendings;
	}

	get appHomeRouter(){
		const paths = this.router.url.split("/");
		return "/apps/" + (paths.length>=2?paths[2]:"");
	}

	private initBreadcrumb(){
		this.parseBreadcrumbByRouting().then(items=>{
			this.items = items;
	    	if(this.appendings){
	    		let appending : any;
	    		for(let i = 0; i<this.appendings.length; i ++){
	    			appending = this.appendings[i]
	    			if(typeof appending === 'string'){
	    				appending = { label: appending };
	    			}
	    			this.items.push(appending);
	    		}
	    	}
		});
	}
	private parseBreadcrumbByRouting() : Promise<any[]> {
		// TODO: 此处实现通过导航数据和当前路由地址分析面包屑
		// 参考：https://segmentfault.com/a/1190000009971757
		// console.log(this.activatedRoute);
		// console.log(this.activatedRoute.snapshot.url);

        return (async () => {

			const paths = this.activatedRoute.pathFromRoot.map(item=>item.url);
			let urls = new Array(paths.length);
			for(let i = 0; i< paths.length; i ++){
				await paths[i].subscribe(url=>urls[i]=url);
			}

			const navMenu = <NavMenu>this.userContext.getData("MainSiderMenu");
			if(navMenu == null) return [];

			// console.log(navMenu);
			// console.log(urls);

			let fullUrl = "";
			urls.map(items=>{
				let url = "";
				items.forEach(item=>{if(item.path&&item.path.length>0) url = url+"/"+item.path;});
				return url;
			}).forEach(url=>{
				if(url&&url.length>0){
					fullUrl = fullUrl + url;
				}
			});

			// console.log("fullUrl="+fullUrl);
			let menuItems:NavMenuItem[] = navMenu.pathFromRootByUrl(fullUrl);
			let breadcrumbItem;
			let breadcrumbItems = [];
			if(menuItems.length>0){
				menuItems.forEach(menuItem=>{
					breadcrumbItem = { label: menuItem.title };
					if(!menuItem.isMatchedUrl(fullUrl)&&menuItem.action&&menuItem.action.length>0){
						if(menuItem.actionType == NavMenuItemActionType.SREF) breadcrumbItem.routerLink = menuItem.action;
						else breadcrumbItem.href = menuItem.action;
					}
					breadcrumbItems.push(breadcrumbItem);
				});
			}
			// console.log(breadcrumbItems);
			return breadcrumbItems;
        })();
	}
}